import { ThemeProvider } from "@mui/material";
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from "react";
import { startMatomo } from "./helpers/matomo";
import { logoutAllTabs } from "./logout";
import Rotas from "./routes/routes";
import queryClient from "./service/query";
import { theme } from "./theme";

const title = document.getElementById('title'); 

if (title) title.innerText = `${process.env.REACT_APP_PROJECT_NAME}`;

function App() {

  useEffect(() => {
    logoutAllTabs();
  }, []);

  useEffect(() => {
    startMatomo();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <Rotas />
        <ReactQueryDevtools initialIsOpen={false} />
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
